import { Link } from "react-router-dom";
import { EyeOff, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useMe } from "@/context/MeContext";
import { Switch } from "@/components/ui/switch";

export const PrivateMode = () => {
  const { me, refresh } = useMe();
  const on = !!me?.settings?.private_mode;
  const set = async (v) => {
    try { await api.put("/me/private-mode", { on: v }); await refresh(); toast.success(v ? "Private mode on: Middle isn't recording your activity" : "Private mode off"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className={`surface flex items-start gap-4 p-5 sm:p-6 ${on ? "border-slate-800" : ""}`} data-testid="private-mode">
      <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${on ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600"}`}><EyeOff size={18} /></span>
      <div className="flex-1 space-y-1">
        <h2 className="text-xl">Private mode</h2>
        <p className="text-sm text-slate-600">Use Middle without being tracked. While it's on, Middle records nothing about what you view, search, read or share, and suggestions use only the topics you chose. Activity already recorded stays until you delete it. Your Story views are still shown to their owners.</p>
        <p className="text-xs font-medium" data-testid="private-mode-state">{on ? "On: no activity is being recorded" : "Off"}</p>
      </div>
      <Switch checked={on} onCheckedChange={set} data-testid="private-mode-switch" aria-label="Private mode" />
    </section>
  );
};

export const SecurityLink = () => (
  <Link to="/security" className="surface flex items-center gap-3 p-4 text-sm transition-colors hover:border-emerald-200" data-testid="security-statement-link">
    <ShieldCheck size={18} className="shrink-0 text-[hsl(var(--facts))]" />
    <span className="flex-1"><b className="font-semibold">How Middle protects your data</b><span className="block text-xs text-slate-500">Encryption, cookies, Private mode and what deleting really means</span></span>
  </Link>
);
